import styled from "@emotion/styled"
import { PAccordion, PHeading } from "@porsche-design-system/components-react"
import {
	colorContrastLow,
	spacingFluidMd,
	spacingFluidXl,
	spacingStaticSm,
} from "@porsche-design-system/components-react/emotion"
import type { TechnicalDataCategoryView } from "@slfinrtl/ui-bff-routes"
import { useState } from "react"
import { Grid, GridItem, List } from "src/components"

interface TechnicalDataProps {
	view: TechnicalDataCategoryView[]
}

export const TechnicalData = ({ view }: TechnicalDataProps) => {
	const [openAccordions, setOpenAccordions] = useState<Record<number, boolean>>({})
	return (
		<Grid $columnGap={{ base: spacingFluidMd, s: spacingFluidXl }}>
			<GridItem size={{ base: 12, m: 6 }}>
				{view.map((category, index) => (
					<PAccordion
						key={index}
						compact
						onUpdate={() =>
							setOpenAccordions((prev) => ({
								...prev,
								[index]: !prev[index],
							}))
						}
						open={openAccordions[index]}
					>
						<PHeading slot="summary" tag="h2" size="sm" weight="semibold">
							{category.name}
						</PHeading>
						<StyledList key={category.name}>
							{category.technicalAttributes?.map((attribute, i) => (
								<List.Item key={i} label={attribute.name} value={attribute.value} />
							))}
						</StyledList>
					</PAccordion>
				))}
			</GridItem>
		</Grid>
	)
}

const StyledList = styled(List)`
	border-top: 1px solid ${colorContrastLow};
	padding-top: ${spacingStaticSm};
`
